import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { SerieModel } from '@/features/list-serie/types';

async function getSeries(): Promise<SerieModel[]> {
  const api = await getApi();
  const { data } = await api.get('/escola/series/serie_nomes/', {
  });
  return data;
}

type QueryFnType = typeof getSeries;

function useSeries() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-series'],
    queryFn: getSeries,
  });
}

export { getSeries, useSeries };
